export default "__VITE_ASSET__B7S9VT2h__"